export function formatCreatedDate(dateString: any, format: string = "default") {
  if (!dateString) return format === "default" ? { date: "-", time: "-" } : "-";

  // Create date object - the date string is already in UTC
  const date = new Date(dateString);

  // Since the input is already in UTC but represents IST time,
  // we don't need to add 5:30 hours
  const day = date.getUTCDate();
  const month = date.toLocaleString("en-US", {
    month: "long",
    timeZone: "UTC",
  });
  const year = date.getUTCFullYear();
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();

  const daySuffix = getDaySuffix(day);

  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHour = hours % 12 === 0 ? "12" : (hours % 12).toString();
  const formattedMinute = minutes < 10 ? `0${minutes}` : minutes.toString();

  const formattedDate = `${day}${daySuffix} ${month} ${year}`;
  const formattedTime = `${formattedHour}:${formattedMinute} ${ampm}`;

  if (format === "date") {
    return formattedDate;
  } else if (format === "time") {
    return formattedTime;
  } else {
    return { date: formattedDate, time: formattedTime };
  }
}

function getDaySuffix(day: any) {
  if (day >= 11 && day <= 13) {
    return "th";
  }
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}
